import Vue from 'vue'

import { Toast } from 'vant'
Vue.use(Toast)
Toast.setDefaultOptions('loading', { forbidClick: true });

import { Swipe, SwipeItem } from 'vant'
Vue.use(Swipe)
Vue.use(SwipeItem)

import { cell } from "vant";
Vue.use(cell);

import { Icon } from 'vant'
Vue.use(Icon)

import { NavBar } from 'vant'
Vue.use(NavBar)

import { Lazyload } from 'vant'
Vue.use(Lazyload, {
    loading: 'http://beautifulchina.oss-cn-hangzhou.aliyuncs.com/tomb-sweeping-day/userId_0_1648700697859_loading.png'
})

import { Popup } from 'vant'
Vue.use(Popup)

import { Progress } from 'vant'
Vue.use(Progress)

import { Step, Steps } from 'vant'
Vue.use(Step).use(Steps)

import { Uploader } from 'vant';
Vue.use(Uploader);

import { Field } from 'vant';
Vue.use(Field);

import { Button } from 'vant';
Vue.use(Button);

import { Picker } from 'vant';
Vue.use(Picker);

import { List } from 'vant';
Vue.use(List);

import { DropdownMenu, DropdownItem } from 'vant';
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

import { PullRefresh } from 'vant';
Vue.use(PullRefresh);

import { Loading } from 'vant';
Vue.use(Loading);

import { Checkbox } from 'vant';
Vue.use(Checkbox);

import { Area } from 'vant';

Vue.use(Area);

import { Image as VanImage } from 'vant';

Vue.use(VanImage);

import { Popover } from 'vant';

Vue.use(Popover);

import { Dialog } from 'vant';

Vue.use(Dialog);
import { ImagePreview } from 'vant';

Vue.use(ImagePreview);

import { CountDown } from 'vant';

Vue.use(CountDown);

import { NoticeBar } from 'vant';

Vue.use(NoticeBar);

import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);

import { RadioGroup, Radio } from 'vant';
Vue.use(Radio);
Vue.use(RadioGroup);

import { PasswordInput, NumberKeyboard } from 'vant';

Vue.use(PasswordInput);
Vue.use(NumberKeyboard);

import { Form } from 'vant';

Vue.use(Form);

import { Search } from 'vant';

Vue.use(Search);